// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"8c7f05a0","269":"bde4625a","644":"76e9fede","743":"537bcb74","963":"e4e4330d"}[chunkId] + ".chunk.js";
};